/**
 * Returns an object that contains the list of IDs for
 * the categories that are used in glossary from airtable.
 */
export const GlossaryCategoriesList = {
  all: "recpR5YrmA7YixItg",
  equipment: "reczjLTb56z6oQcvq",
  reagent: "recmEDZ0UOfHFs6lP",
  concepts: "recBklHCKHNWAfkhN",
  techniques: "recjfi4EEJY556cGg",
  experimentalOutcomes: "recdi6KFa9uYHiDlT",
  verificationTechniques: "recZqRW6ymjI7lvm4",
};
